import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { __ } from "@jti/fe-common";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { ResponsiveImage } from "../../../../components/ResponsiveImage";
import { useCurrentBreakpoint } from "../../../../hooks/useCurrentBreakpoint";
import { FlavorFinderResultCardSpec } from "../ResultsCardSpec/FlavorFinderResultsCardSpec";
export const FlavorFinderResultCard = ({ result, isHiglighted = false, intensityLabel = __("flavorfinder.intensity.label"), flavorLabel = __("flavorfinder.power.label"), coolingLabel = __("flavorfinder.cooling.label"), onClick, index, }) => {
    const { sku, brand, title, description, intensity, flavor, cooling, bgGradientAngle, bgGradientColorFrom, bgGradientColorTo, regularImageDesktop, regularImageTablet, regularImageMobile, exposedImageDesktop, exposedImageTablet, exposedImageMobile, splashImageTablet, splashImageDesktop, } = result;
    const { isSmall } = useCurrentBreakpoint();
    const [gradientBackground, setGradientBackground] = useState("");
    useEffect(() => {
        setGradientBackground(`linear-gradient(${bgGradientAngle}, ${bgGradientColorFrom}, ${bgGradientColorTo})`);
    }, [isSmall, bgGradientAngle, bgGradientColorFrom, bgGradientColorTo]);
    const renderBackroundImages = () => {
        return !isSmall ? (_jsx("div", { className: "flavorfinder__result-background", children: _jsx(ResponsiveImage, { largeSrc: splashImageDesktop, mediumSrc: splashImageTablet, className: "responsive-image__container" }) })) : null;
    };
    const renderCardImage = () => {
        return (_jsx("div", { className: "flavorfinder__result-card-image", children: isHiglighted ? (_jsx(ResponsiveImage, { largeSrc: exposedImageDesktop, mediumSrc: exposedImageTablet, smallSrc: exposedImageMobile, className: "responsive-image__container" })) : (_jsx(ResponsiveImage, { largeSrc: regularImageDesktop, mediumSrc: regularImageTablet, smallSrc: regularImageMobile, className: "responsive-image__container" })) }));
    };
    const handleCardClick = () => {
        if (isHiglighted) {
            return;
        }
        const itemName = `${brand} ${title}`;
        const selectedItemData = {
            currency: "N/A",
            value: "N/A",
            ecommerce: {
                items: [
                    {
                        item_id: sku || itemName,
                        currency: "N/A",
                        price: "N/A",
                        discount: "N/A",
                        quantity: "1",
                        index: "0",
                        item_brand: brand,
                        item_category: "N/A",
                        item_category2: "N/A",
                        item_name: itemName,
                        item_color: bgGradientColorFrom,
                        item_flavor: String(flavor),
                        item_strength: String(intensity),
                        item_coupon: "N/A",
                        item_coupon_type: "N/A",
                        item_list_id: "N/A",
                        item_list_name: "N/A",
                        item_rewards: "N/A",
                        item_sku: sku,
                        carton_format: "N/A",
                        carton_quantity: "N/A",
                        purchase_type: "N/A",
                    },
                ],
            },
        };
        dispatchTrackingEvent(TrackingEvents.TrackingSelectItem, selectedItemData);
        onClick(index);
    };
    const resultCardStyle = { background: gradientBackground };
    return (_jsxs("button", { className: classNames("flavorfinder__result", { "flavorfinder__result--highlighted": isHiglighted }), onClick: handleCardClick, "data-testid": "FlavorfinderResultsCard", children: [renderBackroundImages(), _jsxs("div", { className: "flavorfinder__result-card", "data-sku": sku, "data-testid": "flavor-finder-result-card", style: resultCardStyle, children: [renderCardImage(), _jsxs("div", { className: "flavorfinder__result-card-text", children: [_jsx("p", { className: "flavorfinder__result-card-brand", children: brand }), _jsx("p", { className: "flavorfinder__result-card-title", children: title }), _jsx("span", { className: "flavorfinder__result-card-description", children: description })] }), _jsxs("div", { className: "flavorfinder__result-card-specs", children: [flavor > 0 && _jsx(FlavorFinderResultCardSpec, { power: flavor, label: flavorLabel }), intensity > 0 && _jsx(FlavorFinderResultCardSpec, { power: intensity, label: intensityLabel }), cooling > 0 && _jsx(FlavorFinderResultCardSpec, { power: cooling, label: coolingLabel })] })] })] }));
};
//# sourceMappingURL=FlavorFinderResultCard.js.map